export default "__VITE_PUBLIC_ASSET__ce9937a3__"